// Atteindre tout le monde (D-103) : les accès de chaque licencié (bureau), les contacts du staff,
// le lien du second parent, ceux qu'une annonce ou une convocation ne touche pas encore.
// Chaque fonction de la base vérifie le droit de l'appelant (banc : « ATTEINDRE TOUT LE MONDE »).
import { supabase } from './supabase';
import type { AccessRow } from '../domain/access';

const db = () => {
  if (!supabase) throw new Error('Base non configurée');
  return supabase;
};
async function must<T>(q: PromiseLike<{ data: unknown; error: { message: string; code?: string } | null }>): Promise<T> {
  const { data, error } = await q;
  if (error) throw Object.assign(new Error(error.message), { code: error.code });
  return data as T;
}
const rpc = <T>(fn: string, args: Record<string, unknown>) => must<T>(db().rpc(fn, args));

/** Le bureau : chaque licencié de l'effectif, son e-mail ou celui de ses parents, où en est son accès. */
export const clubAccessList = async (clubId: string) => (await rpc<AccessRow[] | null>('club_access_list', { p_club: clubId })) ?? [];

export interface ContactParent { name: string | null; relation: string | null; email: string | null; phone: string | null; account: boolean }
export interface Contacts { first_name: string; minor: boolean; emails: string[]; phone: string | null; parents: ContactParent[] }
/** Le staff d'une équipe (ses coachs, le responsable technique, le bureau) : joueuse et parents. */
export const personContacts = (personId: string) => rpc<Contacts>('person_contacts', { p_person: personId });

/** Un parent : le lien de l'autre parent pour son enfant (un seul usage, 7 jours). */
export const guardianInviteLink = (personId: string) =>
  rpc<{ token: string; created_at: string; expires_at: string; opened_at: string | null }>('guardian_invite_link', { p_person: personId });

export interface Unreached { person_id: string; first_name: string; minor: boolean; account: boolean; team_id?: string | null }
/** Une annonce : l'effectif visé qui n'est pas encore dans l'app. */
export const announcementUnreached = async (clubId: string, audience: unknown) =>
  (await rpc<Unreached[] | null>('announcement_unreached', { p_club: clubId, p_audience: audience })) ?? [];

export interface EventReach {
  team_id: string; team: string; gender: 'F' | 'M' | 'X'; club: string; title: string; opponent: string | null; is_home: boolean | null;
  day: string; time: string; location: string | null; people: Unreached[];
}
/** Une convocation (le match d'un jour) : de quoi écrire le message, et les convoqués hors de l'app. */
export const eventUnreached = (eventId: string, date: string) => rpc<EventReach>('event_unreached', { p_event: eventId, p_date: date });
